/**
 * Map of US state names to their 2-letter state codes.
 * Includes common variations and abbreviations.
 */
const STATE_NAME_TO_CODE_MAP: Record<string, string> = {
  alabama: "AL",
  alaska: "AK",
  arizona: "AZ",
  arkansas: "AR",
  california: "CA",
  colorado: "CO",
  connecticut: "CT",
  delaware: "DE",
  florida: "FL",
  georgia: "GA",
  hawaii: "HI",
  idaho: "ID",
  illinois: "IL",
  indiana: "IN",
  iowa: "IA",
  kansas: "KS",
  kentucky: "KY",
  louisiana: "LA",
  maine: "ME",
  maryland: "MD",
  massachusetts: "MA",
  michigan: "MI",
  minnesota: "MN",
  mississippi: "MS",
  missouri: "MO",
  montana: "MT",
  nebraska: "NE",
  nevada: "NV",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new mexico": "NM",
  "new york": "NY",
  "north carolina": "NC",
  "north dakota": "ND",
  ohio: "OH",
  oklahoma: "OK",
  oregon: "OR",
  pennsylvania: "PA",
  "rhode island": "RI",
  "south carolina": "SC",
  "south dakota": "SD",
  tennessee: "TN",
  texas: "TX",
  utah: "UT",
  vermont: "VT",
  virginia: "VA",
  washington: "WA",
  "west virginia": "WV",
  wisconsin: "WI",
  wyoming: "WY",
  // Federal districts and territories
  "district of columbia": "DC",
  "washington dc": "DC",
  "washington d.c.": "DC",
  "puerto rico": "PR",
  "american samoa": "AS",
  guam: "GU",
  "northern mariana islands": "MP",
  "u.s. virgin islands": "VI",
  "virgin islands": "VI",
};

/**
 * Converts a US state name to its 2-letter state code.
 * getStateCode("Ohio") // returns "OH"
 * getStateCode("ohio") // returns "OH"
 * getStateCode("OHIO") // returns "OH"
 * getStateCode("Invalid State") // returns ""
 */
export const getStateCode = (stateName: string): string => {
  if (!stateName || typeof stateName !== "string") {
    return "";
  }

  const normalizedName = stateName.trim().toLowerCase();

  return STATE_NAME_TO_CODE_MAP[normalizedName] || "";
};
